export * from './LegacyIcon';
